import type { IMosaicTocExpanded } from "./interface";

/**
 * Hides the major-version alert and clears its navigation target.
 *
 * @param state - The current expanded ToC state.
 * @returns The updated ToC state with no active save alert.
 */
export const toc_closeTocSaveAlert = (state: IMosaicTocExpanded): IMosaicTocExpanded => ({
  ...state,
  showSaveAlert: false,
  tocIdFromMessage: undefined,
});
